import React, { useEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import LabelQuestion from '../../common/LabelQuestion';
import { SUPPLIES_TABS_NAME } from '../../../config';

const Wrapper = styled('div')`
  .item-batch-accounting__wrapper {
    gap: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .item-batch-accounting__number {
      font-weight: 500;
      font-size: 0.9rem;
      max-width: 100px;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: text;
    }

    .accounting-number--editable {
      color: #7e57c2;
      cursor: pointer;
    }

    .item-batch-accounting__expiration-date {
      font-size: 11px;
      color: #72747b;
      white-space: nowrap;
      cursor: text;
    }

    .expiration-date--editable {
      cursor: pointer;
    }

    .help-tooltip-wrapper .help-tooltip {
      left: 20px;
      top: 0;
      max-width: 200px;

      @media (max-width: 400px) {
        top: 20px;
        right: -100px;
        left: auto;
      }
    }
  }
`;

const ContentWrapper = styled('div')`
  .item-batch-accounting-detail__wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .item-batch-accounting-detail__item {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .item-batch-accounting-detail__label {
        font-size: 11px;
        font-weight: 700;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        i {
          color: #98a6ad;
        }
      }
      .item-batch-accounting-detail__value {
        font-size: 11px;
        color: #72747b;
        margin: 0;
        word-break: break-all;
      }
    }
  }
`;

const batchAccountingDetailInfo = [
  { key: 'batchAccountingNumber', title: 'Номер партии' },
  { key: 'productionDate', title: 'Дата изготовления', icon: <i className="fe-calendar" /> },
  { key: 'expirationDate', title: 'Годен до', icon: <i className="fe-calendar" /> },
  { key: 'expirationDays', title: 'Срок годности в днях', icon: <i className="fe-calendar" /> },
  { key: 'manufacturer', title: 'Производитель' },
  { key: 'manufacturerRequisites', title: 'Реквизиты производителя' },
];

const BatchInfoItem = ({ infoItem, infoItemDataByKey }) => (
  <div key={infoItem.key} className="item-batch-accounting-detail__item">
    <p className="item-batch-accounting-detail__label">
      {infoItem.title}
      {infoItem.icon ? infoItem.icon : null}
    </p>
    <p className="item-batch-accounting-detail__value">{infoItemDataByKey ?? '-'}</p>
  </div>
);

export const BatchAccountingInfoContent = ({ currentSupplyItem, batchAccountingDataKey }) => {
  return (
    <ContentWrapper>
      <div className="item-batch-accounting-detail__wrapper">
        {batchAccountingDataKey === 'batchAccountingAttributes' &&
          batchAccountingDetailInfo.map(
            (
              infoItem, // потому что в этом ключе объект
            ) => (
              <BatchInfoItem
                infoItem={infoItem}
                infoItemDataByKey={currentSupplyItem?.batchAccountingAttributes?.[infoItem.key]}
                batchAccountingDataKey={batchAccountingDataKey}
              />
            ),
          )}
        {batchAccountingDataKey === 'factBatchAccountingAttributes' &&
          currentSupplyItem?.factBatchAccountingAttributes.map(
            (
              attr, // потому что в этом ключе массив объектов
            ) =>
              batchAccountingDetailInfo.map((infoItem) => (
                <BatchInfoItem
                  infoItem={infoItem}
                  infoItemDataByKey={attr?.[infoItem.key]}
                  currentSupplyItem={currentSupplyItem}
                  batchAccountingDataKey={batchAccountingDataKey}
                />
              )),
          )}
      </div>
    </ContentWrapper>
  );
};

const InfoDesktopWrapper = styled('div')`
  position: absolute;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;

  .help-tooltip {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
  }
`;

export const BatchAccountingInfoDesktop = ({
  itemIndex,
  currentSupply,
  activeTab,
  batchAccountingDataKey,
}) => {
  const [pos, setPos] = useState({ left: 1000, top: 1000 });

  let currentSupplyItem = currentSupply?.[activeTab][itemIndex];

  useEffect(() => {
    let item = document.querySelector(`#item-index-${itemIndex}`);
    setPos({
      left: (item?.offsetLeft || 0) + 45,
      top: (item?.offsetTop || 0) + 75,
    });
  }, [itemIndex]);

  return (
    <InfoDesktopWrapper left={pos.left} top={pos.top}>
      <span className="help-tooltip-wrapper">
        <span className="help-tooltip" style={{ display: 'block' }}>
          {currentSupplyItem ? (
            <BatchAccountingInfoContent
              currentSupplyItem={currentSupplyItem}
              activeTab={activeTab}
              batchAccountingDataKey={batchAccountingDataKey}
            />
          ) : null}
        </span>
      </span>
    </InfoDesktopWrapper>
  );
};

export const BatchAccountingInfoBlock = (props) => {
  const {
    isMobile,
    itemIndex,
    currentSupplyItem,
    showBatchAccInfo,
    handleEditBatchOrderItem,
    activeTab,
    shouldEnableEditingByStatus,
    batchAccountingDataKey,
  } = props;

  const showBatchAttributesDataByKey = (attribute) =>
    batchAccountingDataKey === 'batchAccountingAttributes'
      ? currentSupplyItem?.batchAccountingAttributes?.[attribute]
      : currentSupplyItem?.factBatchAccountingAttributes?.[0][attribute];

  return (
    <Wrapper>
      <div className="item-batch-accounting__wrapper">
        <div>
          <div
            className={`item-batch-accounting__number ${
              activeTab === SUPPLIES_TABS_NAME.PLAN && shouldEnableEditingByStatus
                ? 'accounting-number--editable'
                : ''
            }`}
            onClick={() => (shouldEnableEditingByStatus ? handleEditBatchOrderItem(itemIndex) : '')}
          >
            {showBatchAttributesDataByKey('batchAccountingNumber') || '-'}
          </div>

          {showBatchAttributesDataByKey('expirationDate') ? (
            <span
              className={`item-batch-accounting__expiration-date ${
                activeTab === SUPPLIES_TABS_NAME.PLAN && 'expiration-date--editable'
              }`}
            >
              До {showBatchAttributesDataByKey('expirationDate')}
            </span>
          ) : null}
        </div>
        <span>
          {isMobile ? (
            <LabelQuestion
              icon="fe-info"
              question={
                <BatchAccountingInfoContent
                  currentSupplyItem={currentSupplyItem}
                  batchAccountingDataKey={batchAccountingDataKey}
                />
              }
              style={{ fontSize: '16px', marginBottom: '-3px' }}
            />
          ) : (
            <span
              id={`item-index-${itemIndex}`}
              className="help-tooltip-wrapper"
              onMouseEnter={() => showBatchAccInfo(itemIndex)}
              onMouseLeave={() => showBatchAccInfo(null)}
            >
              <i className={'fe-info'} />
            </span>
          )}
        </span>
      </div>
    </Wrapper>
  );
};
